/* ARRAY - the brand-row carousel ("Skin Glow Essentials", and the Rhode row
   that shares this script while it is hidden). Arrows, a live "07 - 10"
   counter, mouse-drag to scroll, and an autoplay that pages every
   `data-interval` ms in a loop.

   ---------------------------------------------------------------------------
   PRODUCT CLICKS WERE BEING SWALLOWED (24 Sep 2026). The client: "clicking
   product images in this section doesn't take to their respective product
   pages". The links were correct - every image sits inside a.ar-shot with the
   right href - and nothing covered them. The DRAG was the culprit, twice over:

   1. THE BROWSER'S OWN IMAGE DRAG. Pressing on an <img> inside a link starts
      native drag-and-drop the moment the pointer moves a pixel or two. That
      fires `pointercancel` instead of `pointerup`, and NO CLICK EVER FIRES -
      the navigation simply does not happen. `dragstart` is now cancelled on
      the row, so the only drag is ours.

   2. A STUCK DRAG. The old code only ended a drag on `pointerup`. After a
      native drag stole the gesture there was no pointerup, so `dragging`
      stayed true, every later mouse movement scrolled the row, `moved` went
      true, and the capture-phase guard below then ate the NEXT click as well.
      `pointercancel` now ends a drag exactly like `pointerup`.

   The "was that a drag or a click?" threshold also went from 3px to 6px: a
   hand on a trackpad routinely moves 3-4px while clicking, and each of those
   clicks was being read as a drag.

   THE COUNTER'S DASH IS A LITERAL CHARACTER, not a \\u escape. This file is
   written through a GraphQL block string, which does not process escapes, so
   an escape typed there lands in the JS doubled and prints as text.
   ---------------------------------------------------------------------------

   AUTOPLAY STARTS WHEN THE ROW IS ON SCREEN, NOT AT PAGE LOAD (24 Sep 2026),
   the same rule the Best Sellers section follows. It used to start at
   DOMContentLoaded, so by the time anyone scrolled down the row had paged
   through itself and they met it mid-way. An IntersectionObserver starts the
   clock on arrival and stops it on leaving. It does NOT pause on hover - the
   client wants it to keep moving wherever the cursor is - only while the row
   is actually being dragged.
*/
(function () {
  'use strict';

  var THRESHOLD = 6;
  var DASH = ' — ';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function build(root) {
    if (root.__ar) return;
    root.__ar = true;

    var row = root.querySelector('[data-ar-row]');
    if (!row) return;

    var total = root.querySelectorAll('.ar-cell').length;
    var now = root.querySelector('[data-ar-now]');
    var wait = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var dragging = false, moved = false, startX = 0, startLeft = 0;
    var timer = null, live = false;

    function gap() { var g = parseFloat(getComputedStyle(row).columnGap); return isNaN(g) ? 0 : g; }
    function cellStep() {
      var c = row.querySelector('.ar-cell');
      if (!c) return 0;
      var w = c.getBoundingClientRect().width;
      return w ? w + gap() : 0;
    }
    function pageStep() { return row.clientWidth + gap(); }
    function atEnd() { return row.scrollLeft + row.clientWidth >= row.scrollWidth - 4; }

    function label() {
      if (!now || !total) return;
      var step = cellStep();
      if (!step) return;
      var per = Math.max(1, Math.round(row.clientWidth / step));
      var first = Math.round(row.scrollLeft / step) + 1;
      if (first > total) first = total;
      var last = Math.min(total, first + per - 1);
      now.textContent = pad(first) + DASH + pad(last);
    }

    function jump(x) { row.scrollTo({ left: x, behavior: 'auto' }); setTimeout(label, 60); }

    function go(dir) {
      if (dir > 0 && atEnd()) { jump(0); return; }
      if (dir < 0 && row.scrollLeft <= 4) { jump(row.scrollWidth); return; }
      var before = row.scrollLeft, target = before + dir * pageStep();
      row.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(row.scrollLeft - before) < 4) row.scrollTo({ left: target, behavior: 'auto' });
        label();
      }, 380);
    }

    /* ---- the clock: only while the row is on screen ---- */
    function start() {
      stop();
      if (!live || total < 2) return;
      timer = setInterval(function () { if (!dragging) go(1); }, wait);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    /* ---- mouse drag, without eating clicks ---- */
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-drag');
      setTimeout(label, 260);
    }

    row.addEventListener('dragstart', function (e) { e.preventDefault(); });

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startLeft = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > THRESHOLD) { moved = true; row.classList.add('is-drag'); }
      if (moved) row.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    /* a real drag must not also count as a click on whatever it ended over */
    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-ar-prev]')) { e.preventDefault(); go(-1); start(); }
      if (e.target.closest('[data-ar-next]')) { e.preventDefault(); go(1); start(); }
    });

    row.addEventListener('scroll', function () {
      if (row.__raf) return;
      row.__raf = requestAnimationFrame(function () { row.__raf = 0; label(); });
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (root.__rz) clearTimeout(root.__rz);
      root.__rz = setTimeout(label, 180);
    });

    label();
    requestAnimationFrame(function () { setTimeout(label, 120); });
    window.addEventListener('load', label);

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          live = entries[i].isIntersecting;
          if (live) start(); else stop();
        }
      }, { rootMargin: '-12% 0px -12% 0px', threshold: 0 }).observe(root);
    } else {
      live = true;
      start();
    }
  }

  function boot() {
    var list = document.querySelectorAll('[data-ar-root]'), i;
    for (i = 0; i < list.length; i++) build(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();